<template>
    <li>
        <ul class="nested-list menu-list">
            <li>
                <div
                    class="is-clickable menu-label section-item is-align-center is-space-between has-text-weight-semibold"
                    style="margin-left: -1.5rem !important"
                    @click="displayReportItems"
                    @keyup="displayReportItems"
                >
                    <div class="is-align-center section-item__text" title="Course Reports">
                        <e-icon :icon="menuClass" />

                        <p>Course Reports</p>
                    </div>
                </div>

                <ul v-show="showReportItems" class="nested-list menu-list">
                    <li>
                        <menu-link route-name="discussion-thread-report">Instructor Engagement</menu-link>
                    </li>
                </ul>
            </li>
        </ul>
    </li>
</template>

<script>
import MenuLink from '@/components/nested-list/nested-list-item/MenuLink.vue';

export default {
    name: 'CourseReportsMenu',

    components: { MenuLink },

    data: () => ({
        showReportItems: false,
    }),

    computed: {
        menuClass() {
            return this.showReportItems ? 'angle-down' : 'angle-right';
        },
    },

    methods: {
        displayReportItems() {
            this.showReportItems = !this.showReportItems;
        },
    },
};
</script>
